module.exports = {
    pleaseWait:'Please wait',
    loading:'loading',
    Billing:'Billing',
    billingTips:'Your Purchased History',
    ID:'ID',
    FAQ:'FAQ',
    TC:'T&C',
    Copyright:'© 2025 All Rights Reserved.',
    GenerateImage:'Generative Art',
    generateTips1:'Our AI image generator brings imagination to life, producing stunning art, illustrations, and photos in seconds. Unleash creativity and express yourself in new ways with the power of AI. Explore endless possibilities, from crafting unique marketing materials to creating beautiful artwork, all with supreme ease and efficiency.',
    generateTips2:'Enter a few words below, and watch beautiGen transform text into incredible art.',
    Prompt:'Prompt',
    PromptTips1:'Tell AI what to draw.',
    PromptTips2:'Tips: describe mood and lighting. See page tips for more.',
    PromptTips3:'Note: AI may not follow instructions and cannot count.',
    Generate:'Generate',
    ChancesLeft:'Chances Left',
    BuyChances:'Buy More Chances',
    generateImageTips1:'Input what you want',
    generatePromptsTips1:'Input what you don\'t want',
    indexTips1:'Daily Free Chance <br /> Available!',
    indexTips2:'Choose one of these',
    ImageRestorer:'Image Restorer',
    Continue:'Continue',
    language0:'Language',
    language:'Choose Language',
    languageTips:'Choose your language here',
    Submit:'Submit',
    change:'Change',
    English:'English',
    Myanmar:'Myanmar',
    Login:'Login',
    Logout:'Log out',
    getCode:'Send',
    loginTips:'Enter your phone number',
    otpTips:'Please enter OTP number',
    profile:'Profile',
    phoneNumber:'Phone Number',
    SubscribedSince:'Subscribed since',
    RemainingChances:'Remaining chances',
    cgtips2:'Only 149ks/daily,<br />please click OK to subscribe.',
    cgtips2W:'Only 599ks/weekly,<br />please click OK to subscribe.',
    cgtips2M:'Only 1999ks/monthly,<br />please click OK to subscribe.',
    OK:'OK',
    PictureRestorer:'Picture Restorer',
    PictureTips1:'Restore, sharpen, and repair pictures with AI. beautiGen builds on the latest research to automatically remove scratches, sharpen colors, and enhance faces, transforming damaged photos into cherished memories. Our free service repairs both color photos and black & white ones.',
    Upload:'Upload',
    PictureTips2:'Has Scratch?',
    Restore:'Restore',
    uploadTips:'Please upload pictures',
    PurchaseChances:'Purchase Chances',
    History:'History',
    purchaseTips1:'Your total chances',
    purchaseTips2:'One Time Purchase',
    Daily:'Daily',
    Weekly:'Weekly',
    OneTime:'One Time',
    Purchase:'Purchase',
    DailyKyats:'149 Kyats',
    WeeklyKyats:'599 Kyats',
    OneTimeChance:'129 Ks/Chance',
    Subscribe:'Subscribe',
    purchaseTips3:'Click Buy Now to buy one more chance',
    BuyNow:'Buy Now',
    comingsoonT:'coming soon',
    logout:'Logout',
    petTitle1:'AI Pets Anime',
    petTitle2:'Choose Style',
    petContent1:' transforms your beloved pet’s photo into a whimsical, anime-style masterpiece. Perfect for pet lovers and anime enthusiasts, beautiGen offers a fun and personalized way to celebrate your furry friends.',
    sexTitle1:'Anime Art',
    sexTitle2:'Choose Gender',
    sexContent1:'Brings your imagination to life by generating anime-style photos based on written prompts. Whether you\'re a fan of anime, a storyteller, or a designer, AI Anime Photo empowers you to create vibrant, high-quality anime-style visuals effortlessly, blending advanced AI with your unique vision.',
    sexContent2:'Watch beautiGen transfor text into incredible art.',
    Female:'Female',
    Male:'Male',
    Style1:'Style 1',
    Style2:'Style 2',
    Style3:'Style 3',
    Comic:'Comic',
    Disney:'Disney',
    Ghibli:'Ghibli',
    Animalanime:'Selfie Anime',
    HumanAnime:'Human Anime',
    Guidance:'Guidance',
    PetAnime:'Pet Anime',
    landTips1:'Generate Stunning Photos &',
    landTips2:'WIN BIG PRIZES!',
    landTips3:'Transform your imagination into reality with beautiGen! From stunning photo generation to artistic masterpieces, beautiGen empowers you to create visuals like never before. Dive into a world of limitless possibilities.',
    show401tip:'Balance not enough',
    show400dailytip:'Time out, please send "ON1" to 548 to win the big prize.',
    show400weeklytip:'Time out, please send "ON7" to 548 to win the big prize.',
    register:'Register',
    invitation:'Invitation',
    invitationTips:'Copy and send invite using the link below',
    InviteNow:'Invite Now',
    copySuccess:'Copy Success!',
    process:'Generating',
    downTips1:'Please copy the link into browser and download.',
    copyLink:'Copy link',
    ChangeHairstyle:'Hairstyle Magic',
    ChangeHairstyle_content_1:'The beautiGen app offers a feature for changing hairstyles, allowing users to try on different haircuts in real-time or via uploaded photos. This feature leverages AI technology to analyze the user’s facial features and suggest hairstyles that suit their face shape, preferences, and style. Users can experiment with various looks, ranging from subtle changes to bold, dramatic transformations, giving them a virtual preview before committing to an actual change. The app provides an easy and fun way for users to explore different hairstyles and find the perfect one for them.',
    ChangeHairstyle_content_2:'Choose your favorite hairstyle below and add your own photo. You will get a beautiful and clear image.',
    SmartCutout:'Background Eraser',
    SmartCutout_content:'beautiGen\'s Background Remove feature allows users to effortlessly remove or replace the background of any image with AI-powered precision. Whether you\'re creating professional product photos, fun social media posts, or artistic edits, this tool ensures a clean, seamless cutout with just one tap.',
    IpIMage:'ID Photo',
    IpIMage_content:'The original image uploaded for the ID photo must ensure that the face of the person is clear, without any obstruction, and the shoulders are level and even. Otherwise, the generation may fail. ',
    landfont3:'Create images from your imagination',
    landfont1:'Create your photo into Anime image',
    landfont2:'Remove the background from your photo',
    landfont4:'Create and try out your Imagined Hairstyles',
    landfont5:'Create your photo into an ID photo',
    select:'Select',
    Monthly:'Monthly',
    landFree:'Free of charge from 10th May to 10th June',
    free:'Free',
    snapbot:'BtgenBot',
    snapbot_hi:'Hi, I’m BtgenBot',
    snapbotTips1:'Fast Search Results',
    snapbotTips2:'Natural Language processing',
    snapbotTips3:'Big Data Analysis',
    snapbotTips4:'AI-powered Algorithms',
    snapbotInput1:'Tap here to start with BtgenBot',
    help_today:'How can I help you today?',
    think_ip:'🤖 Thinking...',
    white:'white',
    blue:'blue',
    '1 inch':'1 inch',
    '2 inches':'2 inch',
    '3 inches':'3 inch',
    re_sub_tip:'You have unsubscribed ?',
    subscribe:'subscribe',
    login_tip_2:'Enjoy 7-day free trial & Get 30 ATOM Star Pointson every renewal',
    redirect_tip:'You will be redirected to the browser.',
    UNSUBSCRIBE:'UNSUBSCRIBE',

}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js